import { render, staticRenderFns } from "./ShippingModalComponent.vue?vue&type=template&id=2834f160&scoped=true&"
import script from "./ShippingModalComponent.vue?vue&type=script&lang=js&"
export * from "./ShippingModalComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2834f160",
  null
  
)

export default component.exports